export const storeManageListNewData = [
  {
    id: 'baseInfo',
    title: '',
    data: []
  }
];
export const tableData = {
  tHead: [
    {
      title: '姓名',
      dataIndex: 'name',
      key: 'name',
    },
    {
      key: 'sex',
      dataIndex: 'sex',
      title: '性别',
    },
    {
      key: 'academic',
      dataIndex: 'academic',
      title: '学历',
    },
    {
      key: 'title',
      title: '职务、职称',
      dataIndex:'title',
    },
    {
      key: 'work',
      title: '在项目的展览中承担的工作',
      dataIndex:'work',
      width:400
    },
  ]
};
